import { render, staticRenderFns } from "./product.affiliate.api.map.row-new.vue?vue&type=template&id=5df4e5a2&"
import script from "./product.affiliate.api.map.row-new.vue?vue&type=script&lang=js&"
export * from "./product.affiliate.api.map.row-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports